/* eslint-disable no-unused-expressions */
import * as React from "react";
import PropTypes from "prop-types";
import _ from "underscore";
import { MenubarContext, SubmenuContext, MenuItemContext } from "../../contexts/Menubar";

const MenuItem = ({ children, ...props }) => {
  const menubarContext = React.useContext(MenubarContext);
  const submenuContext = React.useContext(SubmenuContext);
  const menuItemContext = React.useContext(MenuItemContext);

  if (!menubarContext && !submenuContext) {
    throw new Error(
      "MenuItem must be used within either a Menubar or Submenu Context"
    );
  }

  const firstRenderRef = React.useRef(false);
  const menuItemRef = React.useRef(null);
  const idRef = React.useRef(_.uniqueId("menuitem--"));

  if (!firstRenderRef.current) {
    firstRenderRef.current = true;
    menubarContext.addMenuItem(idRef.current, menuItemContext ? menuItemContext.menuItemId : null, props.name);
  }

  const listItemProps = {
    ...props,
    ref: menuItemRef,
    role: "none",
    "data-menubar-listitem": !submenuContext ? "" : null,
    "data-menubar-submenu-listitem": submenuContext ? "" : null
  };

  const childProps = {
    tabIndex: "0",
    "data-menubar-menuitem": !submenuContext ? "" : null,
    "data-menubar-submenu-menuitem": submenuContext ? "" : null
  };

  /*React.useEffect(() => {
    const menuItemNode = menuItemRef.current;

    if (menuItemNode) {
      if (!menuItems.size) {
        setIsFirstChild(true);
      }

      menuItems.add(menuItemNode);
    }

    return () => {
      menuItems.delete(menuItemNode);
    };
  }, [menuItems]);*/

  const value = React.useMemo(() => ({
    menuItemId: idRef.current
  }), []);

  return (
    <MenuItemContext.Provider value={value}>
      <li {...listItemProps}>
        {typeof children === "function"
          ? children(childProps)
          : React.cloneElement(children, childProps)}
      </li>
    </MenuItemContext.Provider>
  );
};

MenuItem.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired
};

export default MenuItem;
